import {Component, OnInit} from '@angular/core';
import {CallTimeticketService} from "./call-timeticket.service";
import {UserService} from "../login/user.service";
import {IPhoto} from "../models/iphoto.model";
import {IStudent} from "../models/istudent.model";
import {finalize} from "rxjs/operators";

@Component({
  selector: 'app-time-ticket',
  templateUrl: './time-ticket.component.html',
  styleUrls: ['./time-ticket.component.css']
})
export class TimeTicketComponent implements OnInit {
  public tt = [];
  public photo: IPhoto = <IPhoto>{};
  public student: IStudent = <IStudent>{};
  public imgLoaded: boolean = false;
  public infoLoaded: boolean = false;

  constructor(private _call: CallTimeticketService, private _login: UserService) {
  }

  ngOnInit() {
    this._call.getPhoto(this._login.pidm).subscribe((photo) => {
      this.photo = photo;
      this.imgLoaded = true;
    });

    this._call.getStudentInfo(this._login.pidm).subscribe((student) => {
      this.student = student;
    });

    this._call.getActiveTerms(this._login.pidm).subscribe(
      (data) => {
        if (data.length == 0) {
          this.infoLoaded = true;
        }
        data.forEach((term) => {
          this._call.getTimeTicket(this._login.pidm, term.clave).pipe(finalize(() => {
            this.tt.sort((a, b) => a.code - b.code);
            this.infoLoaded = true;
          })).subscribe(
            (timeTicket) => {
              this.tt.push({code: term.clave, term: term.nombre, timeTicket: timeTicket.toUpperCase()});
            }
          );
        });
      }
    );
  }
}
